<!--试卷中心主页面-->
<template>
  <div class="Questionnaire_context">
    <div class="Questionnaire_SetContext">
      <div class="Questionnaire_SetContext_title">
        <div>
          <a-row>
            <a-col :span="12">
              <span>试卷标题:</span>
              <el-input class="exam_title" v-model="exam.name" />
            </a-col>
            <a-col :span="12">
              <span>试卷总分数: {{getScore()}} 分</span>
            </a-col>
          </a-row>
        </div>
        <div>
          <div>
            <!-- <el-button type="primary">全选</el-button> -->
            <!-- <el-button type="primary">删除</el-button> -->
            <el-button type="primary" @click="handleClick(0, 'Xt')"
              >选题</el-button
            >
            <!-- <el-button type="primary">排序</el-button> -->
            <!-- <el-button type="primary">批量设置分数</el-button> -->
            <!-- <el-button type="primary">预览</el-button> -->
            <el-button type="primary" @click="save">保存</el-button>
            <el-button type="primary" @click="cancel">返回列表</el-button>
          </div>
        </div>
      </div>

      <div
        class="Questionnaire_SetContext_context"
        :class="Questionnaire_Border"
      >
        <div
          v-if="exam.examQuestions.length <= 0"
          class="Questionnaire_SetContext_context_defult"
        >
          还没有选择试题哦...
        </div>
        <div v-else>
          <div v-for="(item, index) in exam.examQuestions" :key="index">
            <div style="min-height: 7rem;margin-bottom: 1.5rem">
              <div>
                第{{ index + 1 }}题:{{ item.questionsList}} ({{getTypeText(item.type)}})
                <el-input
                  v-model="item.score"
                  type="number"
                  style="width: 10rem; float: right"
                  placeholder="设置分数"
                ></el-input>
              </div>

              <div v-if="item.type == 0 || item.type == 1">
                <!-- 单选 -->
                <div v-for="(obj, idx) in item.examQuestionsOptions" :key="idx">
                  {{ idx + 1 }}.{{ obj.optionsList }}
                </div>
              </div>

              <div v-else>
                <!-- 简答 -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Questionnaire_SetOverall">
      <el-tabs
        v-model="activeName"
        type="card"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane label="全局设置" class="Questionnaire_SetOverall_pane">
          <div class="Questionnaire_SetOverall_Global">
            <span>答题时长</span>
            <el-input v-model="exam.answerDate" placeholder="答题时长" type="number" />(分钟)
          </div>
          <div class="Questionnaire_SetOverall_Global">
            <span>及格分</span>
            <el-input v-model="exam.passScore" placeholder="及格分" type="number" />
          </div>

          <div class="Questionnaire_SetOverall_Global">
            <span>开始时间</span>
            <el-date-picker v-model="exam.startDate" placeholder="开始时间" type="datetime" clearable format="YYYY-MM-DD HH:mm:ss" />
          </div>

          <div class="Questionnaire_SetOverall_Global">
            <span>结束时间</span>
            <el-date-picker v-model="exam.endDate" placeholder="结束时间" type="datetime" clearable format="YYYY-MM-DD HH:mm:ss" />
          </div>

          <div class="Questionnaire_SetOverall_Global">
            <span>是否随机</span>
            <el-switch v-model="exam.isRandom" placeholder="是否随机" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <QuestionBankList
      ref="QuestionBankListRef"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></QuestionBankList>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
// import XEUtils from "xe-utils";

import { ExamList } from "@/assets/apiData/Exam/ExamList";
import QuestionBankList from "@comp/YZExam/QuestionBankList.vue";
import {
  GetExamInfoById,
  ModifyExamData,
  AddExamData,
} from "@api/Exam/ApiExam";
import { dateFormat } from "@/util/utils.js";

export default {
  name: "ExamManagement",
  data() {
    return {
      router: useRouter(),
      exam: {
        id: 0,
        examQuestions: [],
      },
      dialogVisible: false,
      param:{
        operation:"Add",
        main:{}
      }
    };
  },
  components: {
    QuestionBankList,
  },
  methods: {
    getScore(){
      return eval(this.exam.examQuestions.map(x=>x.score).join("+"))
    },
    getTypeText(type){
      return type==0?"单选":type==1?"多选":"简答"
    },
    initParam(){
      this.exam = {
        id: 0,
        examQuestions: [],
      },
      this.param={
        operation:"Add",
        main:{}
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    getExamQuestion(item) {
      //item 是 题库题目对象(包含题目选项)
      var obj = {
        examId: this.exam.id,
        questionBankListId: item.id,
        score:0,
        isShowScore:false,
        isRandom:false,
        type:item.type,
        questionsList:item.questionsList,
        analysis:item.analysis,
        isManyanswers:false,
        examQuestionsOptions: [], //试卷选项
      };
      item.questionBankListOptionses.forEach(x => {
        var option = {
          id: 0,
          examQuestionsId: 0,
          questionBankListOptionsId: x.id,
          questionsScore: 0,
          number: 0,
          isTrue: x.isTure,
          optionsList: x.optionsList,
          keyword: x.keyword,
          marryType: x.marryType,
        };
        obj.examQuestionsOptions.push(option);
      });
      return obj;
    },
    handleConfirm(val) {
      let _this = this;
      _this.dialogVisible = false;

      console.info(val);

      //val 是题库题目 (包含题目选项)
      //debugger;
      //需要删除的
      _this.exam.examQuestions.forEach(ele => {
        //debugger
        if (!val.find(x => x.id == ele.questionBankListId)) {
          _this.exam.examQuestions.splice(
            _this.exam.examQuestions.indexOf(ele),
            1
          );
        }
      });

      val.forEach(ele => {
        if (
          !_this.exam.examQuestions.find(x => x.questionBankListId == ele.id)
        ) {
          //题库题目 转 试卷题目 (包括题目选项)
          _this.exam.examQuestions.push(_this.getExamQuestion(ele));
        }
      });

      debugger;
      console.log(_this.exam.examQuestions)
    },
    save() {
      let _this = this;
      debugger;
      //_this.set()
      if (this.param.operation=='Add') {
        AddExamData(this.exam)
          .then((res) => {
            debugger;
            _this.$message.success("保存成功!");

            localStorage.removeItem("Exam_senddata");

            _this.router.replace({
              name: "考试管理",
              params: {
                from: "ExamManagementEdit",
                isReplace: true,
              },
            });
          })
          .catch((res) => {
            _this.$message.error(res.message);
          });
      } else {
        ModifyExamData(this.exam)
          .then((res) => {
            debugger;
            _this.$message.success("保存成功!");

            localStorage.removeItem("Exam_senddata");

            _this.router.replace({
              name: "考试管理",
              params: {
                from: "ExamManagementEdit",
                isReplace: true,
              },
            });
          })
          .catch((res) => {
            _this.$message.error(res.message);
          });
      }
    },
    cancel(){
      localStorage.removeItem("Exam_senddata");

      this.router.replace({
        name: "考试管理",
        params: {
          from: "ExamManagementEdit",
          isReplace: true,
        },
      });
    },
    handleClick(index, type) {
      var _this = this;
      if (type == "Xt") {
        this.dialogVisible = true;
        debugger

        this.$refs.QuestionBankListRef.loadDataById("", type,this.exam.examQuestions.map(x=>x.questionBankListId));
      } else if (type == "Delete") {
        DeleteQuestionBank(_this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else if (type == "Add") {
        localStorage.setItem(
          "Exam_senddata",
          JSON.stringify({ operation: type, main: _this.DataList[index] })
        );

        this.router.replace({
          name: "试卷中心",
          params: {
            from: "ExamManagement",
            isReplace: true,
          },
        });
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.QuestionBankListRef.loadDataById(id, type);
      }
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "status":
          cellValue = this.statusList.map((x) => x.code == cellValue).name;
          break;
      }
      return cellValue;
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    GetData() {
      const _this = this;
      if(_this.param.operation=='Add')return
      try {
        GetExamInfoById(_this.param.main.id).then(function (data) {
         _this.exam = data
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    debugger
    this.initParam()
    var senddata = localStorage.getItem('Exam_senddata')
    //跳转过来携带的参数
    let { operation, main } = JSON.parse(senddata);
    this.param.operation = operation
    this.param.main = main

    this.ExamList = ExamList;
    this.GetData();
  },
};
</script>


<style lang="scss" scoped>
.Questionnaire_context {
  display: flex;
  //height: 100%;
  min-height: 600px;
  font-size: 20px;
  // color: #24335A;
  font-family: PingFang SC-Regular;

  .Questionnaire_type {
    width: 224px;
    position: relative;
    background-color: #ffffff;
    padding: 0 10px;

    .Questionnaire_type_title {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
      margin-left: 10px;
      display: inline-block;
      line-height: 70px;
      height: 67px;
    }

    .Questionnaire_type_selectTitle {
      font-size: 16px;
      font-weight: 500;
      margin: 10px 0px 8px 10px;
      color: #33404e;
      display: inline-block;
      line-height: 20px;
      height: 20px;
    }

    .Question_Type_Seclect {
      display: flex;
      justify-content: flex-start;
    }

    .Question_Type_Seclect_img {
      width: 20px;
      height: 20px;
    }

    .QuestionType {
      border: solid 1px #707070;
      background-color: #ffffff;
      border-radius: 2px;
      padding: 0 5px;
      width: 80px;
      height: 30px;
      margin-left: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        margin-left: 10px;
      }

      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 30px;
      }
    }

    .QuestionType:hover {
      border: solid 1px blue;
      color: blue;
      background-color: #f0e7e7ad;
    }

    .Question_Type_Save {
      position: absolute;
      left: 20px;
      bottom: 18px;
      .Question_Type_BackButton {
        width: 87px;
        max-height: 40px;
        min-height: 40px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #202020;
        line-height: 32px;
        padding: 0;
        border: solid 1px #707070;
      }
      .Question_Type_SaveButton {
        width: 87px;
        max-height: 40px;
        min-height: 40px;
        background: #0747a6;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        padding: 0;
        border: solid 1px;
      }
    }

    hr {
      height: 1px;
      background-color: #d8dee8;
      border: none;
    }
  }

  .Questionnaire_SetContext {
    width: 80%;
    // height: 100%;
    // background-color: gold;
    padding: 0 20px;

    .Questionnaire_SetContext_title {
      //height: 20%;
      padding: 10px 20px;
      background-color: #ffffff;
    }
    .exam_title {
      width: 15rem;
    }
    .Questionnaire_SetContext_context {
      // height: 50%;
      min-height: 300px;
      margin: 10px 0;
      //border: dashed 1px #707070;
      position: relative;

      .Questionnaire_SetContext_context_defult {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .Questionnaire_SetContext_bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      min-height: 100px;

      // height: 20%;
      .Questionnaire_SetContext_bottom_context {
        text-align: center;
        margin-top: 34px;
        margin-bottom: 19px;
        .issuebtn {
          width: 90px;
          max-height: 32px;
          min-height: 32px;
          background: #0747a6;
          border-radius: 2px 2px 2px 2px;
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
          padding: 0;
        }
      }

      .Questionnaire_SetContext_bottom_context span {
        display: inline-block;
        font-size: 14px;
        color: #33404e;
        //background-color: red;
      }
    }
  }

  .Questionnaire_SetOverall {
    height: 100%;
    background-color: #ffffff;
    .Questionnaire_SetOverall_pane {
      padding: 0 5px;
      hr {
        height: 1px;
        background-color: #d8dee8;
        border: none;
      }
    }

    .Questionnaire_SetOverall_Global {
      //  background-color: chartreuse;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px;
      border-bottom: solid 1px #d8dee8;
      .Questionnaire_SetOverall_Global_Set {
        color: #0747a6;
        max-height: 21px;
        min-height: 21px;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        line-height: 21px;
        padding: 0;
      }
    }

    .Questionnaire_SetOverall_Global span {
      font-size: 16px;
      color: #24335a;
    }

    .Questionnaire_SetOverall_titleType {
      width: 75px;
      color: red;
    }

    .Questionnaire_SetOverall_title {
      display: inline-block;
      font-size: 16px;
      font-weight: 600;
      color: #24335a;
      padding: 10px 10px;
    }

    .Questionnaire_SetOverall_tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.Questionnaire_Border {
  border: dashed 1px #707070;
}
</style>

<style scoped>
.data_Title /deep/ .el-input__inner {
  font-size: 20px;
  color: #262a33;
}
.Questionnaire_SetContext_bottom_context /deep/ .el-input__inner {
  font-size: 16px;
  color: #262a33;
  font-weight: 700;
  text-align: center;
  border: 0;
  margin: 10px 0;
}
.Questionnaire_SetContext_bottom_context /deep/ .el-input__inner:focus {
  border: dashed 1px #707070;
}

.demo-tabs /deep/ .el-tabs__item.is-active {
  color: #0747a6;
  font-family: PingFang SC-Regular;
  font-size: 16px;
}
.demo-tabs /deep/ .el-tabs__item:hover {
  color: #0747a6;
  cursor: pointer;
}
</style>


